import { Helmet } from "react-helmet-async";
import { serializeJsonLd, SITE_ORIGIN } from "../../shared/seoJsonLd";

interface SeoHelmetProps {
  path: string; // e.g. "/vs/tradezella"
  title: string;
  description: string;
  jsonLd?: Record<string, any>[];
}

export default function SeoHelmet({ path, title, description, jsonLd }: SeoHelmetProps) {
  const canonical = `${SITE_ORIGIN}${path}`;
  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      {(jsonLd ?? []).map((node, i) => (
        <script key={i} type="application/ld+json">
          {serializeJsonLd(node)}
        </script>
      ))}
    </Helmet>
  );
}
